function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BankOfAmerica = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    fill: "#E31837",
    fillRule: "evenodd",
    d: "M19.94 30.843C26.256 25.428 35.127 20.166 40 18.27c-.752-.482-1.925-1.174-3.248-1.925-6.286 2.075-13.625 6.677-20.181 11.88 1.113.841 2.286 1.714 3.369 2.617Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#012169",
    fillRule: "evenodd",
    d: "M17.052 16.136c-.932-.452-1.954-.873-2.736-1.233-2.376 1.172-5.474 2.947-9.383 5.744.842.451 1.744.992 2.706 1.534 3.008-2.226 6.045-4.331 9.413-6.045ZM9.232 13.158C5.715 14.783 2.016 17.008 0 18.301c.722.33 1.443.602 2.436 1.082 4.45-3.007 7.94-4.842 9.323-5.443-.992-.362-1.925-.602-2.527-.782Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#E31837",
    fillRule: "evenodd",
    d: "M22.677 13.55c-1.144-.633-5.113-2.107-7.85-2.738-.812.301-1.955.752-2.737 1.083.992.27 4.692 1.263 7.85 2.857.812-.391 1.955-.872 2.737-1.203ZM25.323 12.617c.812-.271 1.745-.512 2.557-.753-2.346-.992-5.293-2.045-7.94-2.707-.42.12-1.684.452-2.557.722.903.272 3.88.963 7.94 2.738ZM10.496 23.925c.962.572 1.985 1.353 2.977 2.015 6.587-5.113 13.083-9.053 20.211-11.278-.992-.511-1.865-.962-2.977-1.504-4.271 1.083-11.58 4-20.211 10.767Z",
    clipRule: "evenodd"
  })]
}));
//# sourceMappingURL=BankOfAmerica.js.map